export const tasksCode = 'kfhn';
export const dogsCode = 'rytw';
export const bicyclesCode = 'gwwb';
export const mapCode = 'qjlb';
export const hrCode = 'kqqs';
export const warehousesCode = 'rxfm';
export const tripsCode = 'olmr';
export const wantedDocumentCode = 'daey';
export const wantedPersonCode = 'wlot';
export const wantedVehiclesCode = 'fkvv';
export const operationalWarehousesCode = 'ospk';



// WEBPACK FOOTER //
// ./src/moduleCodes.ts